/* eslint-disable no-shadow */
export enum CommunityStatuses {
  PUBLISHED = 'Published',
  PRE_ORDER = 'Pre-order',
  DRAFT = 'Draft',
}
